import * as React from "react";
import { chakra } from "@chakra-ui/react";
import { Text } from "slate";
import { Marks } from "../../duck";

type Leaf = Text & Marks;

interface LeafProps {
  attributes: { [key: string]: any };
  leaf: Leaf;
  children?: React.ReactNode;
}

const Leaf: React.FC<LeafProps> = ({ attributes, children, leaf }) => {
  let newChildren = children;

  if (leaf.bold) {
    newChildren = <strong>{newChildren}</strong>;
  }

  if (leaf.italic) {
    newChildren = <em>{newChildren}</em>;
  }

  if (leaf.underline) {
    newChildren = <u>{newChildren}</u>;
  }

  return <chakra.span {...attributes}>{newChildren}</chakra.span>;
};

export default Leaf;
